module.exports = __webpack_public_path__ + "img/-LV56i17sYXz4CLF6YHC.8f1c36bd.jpg";